import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";
import { Category } from "@styled-icons/boxicons-regular/Category";
import { School } from "@styled-icons/ionicons-outline/School";
import { Newspaper } from "@styled-icons/ionicons-outline/Newspaper";
import { PaperPlane } from "@styled-icons/ionicons-outline/PaperPlane";
import { DeleteDismiss } from "@styled-icons/fluentui-system-regular/DeleteDismiss";
import { LearningApp } from "@styled-icons/fluentui-system-regular/LearningApp";
import { Check2Circle } from "@styled-icons/bootstrap/Check2Circle";
import { Create } from "@styled-icons/ionicons-outline/Create";
import { PencilSquare } from "@styled-icons/bootstrap/PencilSquare";

import Foto from "../../assets/img/topo.jpg";

export const MainWrapper = styled.div`
  background: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;
  padding: 20px 0;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    margin-left: -15px;
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    a {
      background: rgba(255, 255, 255, 0.1);
      margin-bottom: 2px;
      color: #fff;
      border-radius: 10px;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
      
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateX(5px);
      }
    }

    hr {
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      margin: 15px 0;
    }
  }

  .btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: block;
    border: none;
    width: 100%;
    border-radius: 12px;
    padding: 12px 20px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
    }
  }

  .card {
    margin: 20px 0;
    border-radius: 20px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.95);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const ChartContainer = styled.div`
  background: rgba(255, 255, 255, 0.98);
  border-radius: 20px;
  padding: 25px;
  margin: 25px 0;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }
  
  h3 {
    color: #333;
    font-weight: 700;
    margin-bottom: 20px;
    text-align: center;
    font-size: 1.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

export const StatsCard = styled.div`
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .stats-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid rgba(102, 126, 234, 0.1);

    h4 {
      margin: 0;
      color: #333;
      font-weight: 600;
      font-size: 1.3rem;
    }
  }

  .stats-value {
    font-size: 2.5rem;
    font-weight: 700;
    color: #007BC6;
    margin-bottom: 0.5rem;
    text-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  }

  .stats-label {
    font-size: 0.9rem;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    font-size: 3rem;
    font-weight: 800;
    margin-bottom: 15px;
    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    color:#007BC6;
  }
  
  p {
    font-size: 1.2rem;
    opacity: 0.9;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
    color:rgb(0, 0, 0);
  }
`;

export const FilterSection = styled.div`
  background: rgba(255, 255, 255, 1);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 30px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #333;
  
  .filter-row {
    display: flex;
    gap: 15px;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .form-control {
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.9);
    padding: 10px 15px;
    transition: all 0.3s ease;
    color: #333;
    
    &:focus {
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
      border-color: #667eea;
    }
  }
  
  .form-label {
    color: #333 !important;
    font-weight: 600;
  }
  
  .btn {
    color: #333 !important;
  }
  
  .text-muted {
    color: #666 !important;
  }
  
  .form-check-label {
    color: #333 !important;
  }
  
  small {
    color: #666 !important;
  }
  
  /* Estilos para períodos selecionados */
  .bg-primary {
    .form-check-label {
      color: #fff !important;
      
      strong {
        color: #fff !important;
      }
    }
    
    .text-white-50 {
      color: rgba(255, 255, 255, 0.7) !important;
    }
  }
`;

export const WrapperTurma = styled.div`
  background-image: url("${Foto}");
  background-position: bottom center;
  background-size: cover;
  display: flex;
  width: 100%;
  height: 250px;
  line-height: 12px;
  font-size: 12px;
  padding: 40px;
  color: #eee;
  flex-direction: column;
  align-content: flex-end;
  justify-content: flex-end;
  margin: 15px 0px;
  border-radius: 10px;

  strong {
    display: inline-block;
    font-size: 32px;
    color: #fff;
    border-bottom: 1px solid #fff;
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right {
    position: relative;
    float: right;
  }
`;

export const TopButton = styled.div`
  position: absolute;
  right: 20px;
  top: 10px;
  z-index: 9;
  cursor: pointer;
`;

export const TipoAviso = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;
  min-height: 60px;
  margin-right: 20px;
  margin-bottom: 15px;
  background-color: #007bc6;
  color: #fff;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CaixaTexto = styled.div`
  display: block;
  width: 100%;
  position: relative;
  min-height: 90px;
  overflow: hidden;
  padding: 10px 0px;
`;

export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const CategoryIcon = styled(Category)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const SchoolIcon = styled(School)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const NewspaperIcon = styled(Newspaper)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const PaperPlaneIcon = styled(PaperPlane)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const DeletarIcone = styled(DeleteDismiss)`
  color: red;
  height: 24px;
  width: 24px;
`;

export const LearningAppIcon = styled(LearningApp)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const CheckIcon = styled(Check2Circle)`
  color: #007bc6;
  height: 16px;
  width: 16px;
`;

export const CreateIcon = styled(Create)`
  color: #fff;
  height: 32px;
  width: 32px;
`;

export const PencilSquareIcon = styled(PencilSquare)`
  color: #fff;
  height: 32px;
  width: 32px;
`;
